import React from 'react';
import { withRouter } from 'react-router-dom';
import { get, debounce } from 'lodash';
import { Form } from 'informed';
import PropTypes from 'prop-types';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ComponentWithToken from './CompontentWithToken';
import {
  InputTypeText,
  FieldSet,
  InputTypeDropdown,
  Spinner,
  InputCpf,
  InputBirth,
} from '../elements';
import ProfilePicture from './ProfilePicture';
import {
  fetchPersonalData,
  fetchPersonalFields,
  validatePersonalData,
} from '../services/personal_data_service';
import { handleUpload } from '../services/upload_service';
import {
  fetchNationalities,
  fetchGenders,
  fetchMaritalStatuses,
  fetchHandicapOptions,
  fetchDisabilities,
  fetchSpecialNeeds,
  fetchCountries,
  fetchStates,
  fetchCities,
} from '../services/options_service';
import HandicapForm from './HandicapForm';
import DisabilitiesForm from './DisabilitiesForm';
import SpecialNeedsForm from './SpecialNeedsForm';
import { Endereco, Contato } from '../forms';
import AutosaveFeedback from './autoSaveFeedBack';
import { API_URL } from '../../lib/const';
import Modal from './ConfirmationModal';
import { fetchOnboarding } from '../v2/onboarding/services/fetch_onboarding';
import InputSocialMedia from '../elements/InputSocialMedia';

class PersonalDataStep extends ComponentWithToken {
  state = {
    loading: true,
    countries: [],
    states: [],
    cities: [],
    profilePicture: undefined,
    profileKey: null,
    dbCep: null,
    uploadingProfileImage: false,
    newer: true,
    errors: [],
    nationalities: [],
    maritalStatuses: [],
    genders: [],
    disabilities: [],
    handicapOptions: [],
    specialNeeds: [],
    selectedDisabilities: [],
    selectedSpecialNeeds: [],
    fields: {},
    nomeSocial: false,
    showConfirmationModalNomeSocial: false,
    onboarding: {},
    dynamicFields: {},
  };

  previousErrors = {};

  componentDidMount() {
    Promise.all([
      this.fetchPersonalData(),
      this.fetchOptions(),
      this.fetchOnboarding(),
      this.loadPersonalFields(),
    ])
      .then(() => {
        this.setState({ loading: false });
        this.setState({ newer: false });
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.setState({ loading: false });
        }
      });
  }

  fetchPersonalData = () =>
    fetchPersonalData(this.token).then((data) => {
      this.formApi.setValues(data);
      this.setState({
        selectedSpecialNeeds: data.special_needs,
        selectedDisabilities: data.disabilities,
        profilePicture: data.profile_img_url || undefined,
      });
      if (data.birth_state) {
        this.fetchCities(data.birth_state);
      }
      if (this.formApi.getState().values.assumed_name) {
        this.setState({ nomeSocial: true });
      }
    });

  loadPersonalFields = async () => {
    try {
      const data = await fetchPersonalFields(this.token);
      const dynamicFieldsMap = {};
      data.dynamic_field_config.fields.forEach((field) => {
        dynamicFieldsMap[field.field_name] = true;
      });
      this.setState({ dynamicFields: dynamicFieldsMap });
    } catch (error) {
      console.error('Erro ao buscar campos:', error);
    }
  };

  fetchOnboarding = async () => {
    await fetchOnboarding({ enrollment_token: this.token }).then((res) => {
      this.setState({ onboarding: res });
    });
  };

  fetchCities = (state) =>
    fetchCities(state).then((response) => this.setState({ cities: response }));

  fetchOptions = () => {
    const options = [
      {
        field: 'nationalities',
        fetchFunction: fetchNationalities,
      },
      {
        field: 'countries',
        fetchFunction: fetchCountries,
      },
      {
        field: 'states',
        fetchFunction: fetchStates,
      },
      {
        field: 'genders',
        fetchFunction: fetchGenders,
      },
      {
        field: 'maritalStatuses',
        fetchFunction: fetchMaritalStatuses,
      },
      {
        field: 'handicapOptions',
        fetchFunction: fetchHandicapOptions,
      },
      {
        field: 'disabilities',
        fetchFunction: fetchDisabilities,
      },
      {
        field: 'specialNeeds',
        fetchFunction: fetchSpecialNeeds,
      },
    ];
    return Promise.all([
      options.map((option) =>
        option.fetchFunction().then((response) =>
          this.setState({
            [option.field]: response,
          })
        )
      ),
    ]);
  };

  validatePersonalData = () => {
    this.setState({ loading: true });
    const { values } = this.formApi.getState();
    const { onClick, subscriptionKind } = this.props;
    const {
      selectedDisabilities,
      selectedSpecialNeeds,
      newer,
      onboarding,
      dynamicFields,
    } = this.state;

    validatePersonalData(this.token, {
      ...values,
      disabilities: selectedDisabilities,
      special_needs: selectedSpecialNeeds,
      fields: dynamicFields,
    })
      .then(() => this.setState({ loading: false }, onClick))
      .catch((error) => {
        this.setState({ loading: false });
        const status = get(error, 'response.status');
        if (status === 400) {
          const errors = get(error, 'response.data');
          Object.keys(this.previousErrors).forEach((fieldName) => {
            if (this.formApi.fieldExists(fieldName)) {
              this.formApi.setError(fieldName, null);
            }
          });

          this.previousErrors = { ...errors };

          Object.entries(errors).forEach((e) => {
            if (this.formApi.fieldExists(e[0])) {
              this.formApi.setError(e[0], e[1]);
            }
          });
        }
      });
  };

  uploadProfilePicture = (event) => {
    const file = get(event, 'target.files.0');
    this.setState({ uploadingProfileImage: true });
    this.updateFeedBack('profile_img_key', 'saving');
    if (file) {
      handleUpload(file)
        .then((response) => {
          const { key } = response.data;
          const { values } = this.formApi.getState();
          values.profile_img_key = key;
          this.formApi.setValues({ ...values });
          this.setState(
            {
              uploadingProfileImage: false,
              profilePicture: URL.createObjectURL(file),
            },
            () => this.partialSavePersonalData('profile_img_key', key)
          );
        })
        .catch(() => {
          this.setState({ uploadingProfileImage: false });
          this.updateFeedBack('profile_img_key', 'error');
        });
    }
  };

  isBrazilian = (formState) =>
    +formState.values.nationality === 1 || +formState.values.nationality === 2;

  displayMilitaryCertificate = (formState) => {
    const { genders } = this.state;
    const gender = genders.find((g) => +formState.values.gender === +g.id);
    return gender && gender.check_military_draft;
  };

  displayDisabilities = (formState) => {
    const { handicapOptions } = this.state;
    const handicapOption = handicapOptions.find(
      (g) => +formState.values.handicap === +g.id
    );
    return handicapOption && handicapOption.check_disabilities;
  };

  handleDisabilityChange = (event, disabilityId) => {
    const { selectedDisabilities } = this.state;
    let disabilities = [];

    if (event.target.checked) {
      disabilities = [...selectedDisabilities, disabilityId];
    } else {
      disabilities = selectedDisabilities.filter((d) => d !== disabilityId);
    }
    this.setState({ selectedDisabilities: disabilities }, () =>
      this.partialSavePersonalData('disabilities', disabilities)
    );
  };

  handleSpecialNeedChange = (event, disabilityId) => {
    const { selectedSpecialNeeds } = this.state;
    let specialNeeds = [];

    if (event.target.checked) {
      specialNeeds = [...selectedSpecialNeeds, disabilityId];
    } else {
      specialNeeds = selectedSpecialNeeds.filter((d) => d !== disabilityId);
    }
    this.setState({ selectedSpecialNeeds: specialNeeds }, () =>
      this.partialSavePersonalData('special_needs', specialNeeds)
    );
  };

  updateFeedBack = (field, status) => {
    const { fields } = this.state;
    fields[field] = status;
    this.setState({ fields });
  };

  partialSavePersonalData = (field, value) => {
    this.updateFeedBack(field, 'saving');
    axios
      .patch(`${API_URL}/personal/personal-data/${this.token}`, {
        [field]: value,
      })
      .then(() => {
        this.updateFeedBack(field, 'ok');
        if (this.formApi.fieldExists(field)) {
          this.formApi.setError(field, null);
        }
      })
      .catch((error) => {
        this.updateFeedBack(field, 'error');
        const status = get(error, 'response.status');
        if (status === 400) {
          const response = get(error, 'response.data');
          this.formApi.setError(field, response[field]);
        }
      });
  };

  debouncedPartialSave = debounce(this.partialSavePersonalData, 400);

  render() {
    const {
      profilePicture,
      loading,
      nationalities,
      countries,
      states,
      cities,
      genders,
      maritalStatuses,
      handicapOptions,
      disabilities,
      selectedDisabilities,
      selectedSpecialNeeds,
      specialNeeds,
      fields,
      uploadingProfileImage,
      nomeSocial,
      showConfirmationModalNomeSocial,
      onboarding,
      dynamicFields,
    } = this.state;

    const { isAcademic, isNAAP, onEdit, subscriptionKind } = this.props;
    return (
      <Form
        id="dado-pessoal"
        getApi={(api) => {
          this.formApi = api;
        }}
      >
        {({ formApi, formState }) => (
          <>
            <Spinner active={loading}>
              {!isNAAP && (
                <>
                  {['required', 'optional'].includes(
                    onboarding.profile_photo_upload_configuration
                  ) &&
                    dynamicFields.profile_img_key && (
                      <ProfilePicture
                        loading={uploadingProfileImage}
                        src={profilePicture}
                        onUpdate={this.uploadProfilePicture}
                        error={get(this.previousErrors, 'profile_img_key[0]')}
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'profile_img_key')}
                          />
                        }
                      />
                    )}
                  <FieldSet>
                    {dynamicFields.real_name && (
                      <InputTypeText
                        autosaveFeedBack={
                          <AutosaveFeedback status={get(fields, 'real_name')} />
                        }
                        disabled={!isAcademic && !subscriptionKind}
                        field="real_name"
                        label="Nome Completo"
                        col="12"
                        helper="Seu nome de registro civil"
                        onValueChange={(value) =>
                          this.debouncedPartialSave('real_name', value)
                        }
                      />
                    )}
                    {dynamicFields.real_name && (
                      <div className="radio-group col-md-12 col-sm-12">
                        <label className="input-check-type">
                          {'Possui nome social?'}
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="nomeSocialInput"
                            checked={nomeSocial}
                            onChange={() =>
                              this.setState({ nomeSocial: !nomeSocial })
                            }
                          />
                          <span className="checkmark" />
                        </label>
                      </div>
                    )}
                    {nomeSocial && dynamicFields.assumed_name && (
                      <InputTypeText
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'assumed_name')}
                          />
                        }
                        field="assumed_name"
                        label="Nome Social"
                        col="6"
                        helper="A informação inserida aqui substituirá o nome de registro civil no sistema."
                        onValueChange={(value) =>
                          this.debouncedPartialSave('assumed_name', value)
                        }
                      />
                    )}
                    {nomeSocial && dynamicFields.assumed_name && (
                      <div className="col-md-6 col-sm-12 bold">
                        <label style={{ fontWeight: 'bold', color: 'red' }}>
                          {' '}
                          ATENÇÃO: Nome social é o modo como a pessoa se
                          autoidentifica e é reconhecida, identificada, chamada
                          e denominada na sua comunidade e no meio social, uma
                          vez que o seu nome civil, isto é, seu nome de registro
                          não reflete a sua identidade de gênero.
                        </label>
                      </div>
                    )}
                    {dynamicFields.nationality && (
                      <InputTypeDropdown
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'nationality')}
                          />
                        }
                        options={nationalities}
                        field="nationality"
                        label="Nacionalidade"
                        col="3"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('nationality', value)
                        }
                      />
                    )}
                    {dynamicFields.birth_country && (
                      <InputTypeDropdown
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'birth_country')}
                          />
                        }
                        options={countries}
                        field="birth_country"
                        label="País de origem"
                        col="3"
                        helper="Ex: Brasil"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('birth_country', value)
                        }
                      />
                    )}
                    {this.isBrazilian(formState) ? (
                      <>
                        {dynamicFields.birth_state && (
                          <InputTypeDropdown
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'birth_state')}
                              />
                            }
                            options={states}
                            field="birth_state"
                            label="UF de Nascimento"
                            col="3"
                            onChange={(e) => this.fetchCities(e.target.value)}
                            disabled={false}
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave('birth_state', value)
                            }
                          />
                        )}
                        {dynamicFields.birth_city && (
                          <InputTypeDropdown
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'birth_city')}
                              />
                            }
                            options={cities}
                            field="birth_city"
                            label="Naturalidade"
                            col="3"
                            helper="Cidade de Nascimento"
                            disabled={false}
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave('birth_city', value)
                            }
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {dynamicFields.foreign_birth_state && (
                          <InputTypeText
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'foreign_birth_state')}
                              />
                            }
                            field="foreign_birth_state"
                            label="UF de Nascimento"
                            col="3"
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave(
                                'foreign_birth_state',
                                value
                              )
                            }
                          />
                        )}
                        {dynamicFields.foreign_birth_city && (
                          <InputTypeText
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'foreign_birth_city')}
                              />
                            }
                            field="foreign_birth_city"
                            label="Naturalidade"
                            col="3"
                            helper="Cidade de Nascimento"
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave(
                                'foreign_birth_city',
                                value
                              )
                            }
                          />
                        )}
                      </>
                    )}
                    {!this.isBrazilian(formState) && dynamicFields.rne && (
                      <InputTypeText
                        autosaveFeedBack={
                          <AutosaveFeedback status={get(fields, 'rne')} />
                        }
                        field="rne"
                        label="RNE"
                        col="3"
                        numbers="15"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('rne', value)
                        }
                      />
                    )}
                    {dynamicFields.cpf && (
                      <InputCpf
                        autosaveFeedBack={
                          <AutosaveFeedback status={get(fields, 'cpf')} />
                        }
                        field="cpf"
                        label="CPF"
                        col="3"
                        helper="Ex: 000.000.000-00"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('cpf', value)
                        }
                      />
                    )}
                    {dynamicFields.birth_date && (
                      <InputBirth
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'birth_date')}
                          />
                        }
                        field="birth_date"
                        label="Data de Nascimento"
                        col="3"
                        helper="Ex: 18/12/2001 - (Dia/Mes/Ano)"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('birth_date', value)
                        }
                      />
                    )}
                    {dynamicFields.gender && (
                      <InputTypeDropdown
                        autosaveFeedBack={
                          <AutosaveFeedback status={get(fields, 'gender')} />
                        }
                        options={genders}
                        field="gender"
                        label="Sexo"
                        col="3"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('gender', value)
                        }
                      />
                    )}
                    {dynamicFields.marital_status && (
                      <InputTypeDropdown
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'marital_status')}
                          />
                        }
                        options={maritalStatuses}
                        field="marital_status"
                        label="Estado Civil"
                        col="3"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('marital_status', value)
                        }
                      />
                    )}
                    {this.isBrazilian(formState) && (
                      <>
                        {dynamicFields.rg && (
                          <InputTypeText
                            autosaveFeedBack={
                              <AutosaveFeedback status={get(fields, 'rg')} />
                            }
                            field="rg"
                            label="RG"
                            col="3"
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave('rg', value)
                            }
                          />
                        )}
                        {dynamicFields.rg_issuing_body && (
                          <InputTypeText
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'rg_issuing_body')}
                              />
                            }
                            field="rg_issuing_body"
                            label="Órgão Emissor"
                            col="3"
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave(
                                'rg_issuing_body',
                                value
                              )
                            }
                          />
                        )}
                        {dynamicFields.rg_issue_date && (
                          <InputBirth
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'rg_issue_date')}
                              />
                            }
                            field="rg_issue_date"
                            label="Data de Expedição"
                            col="3"
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave('rg_issue_date', value)
                            }
                          />
                        )}
                        {dynamicFields.electoral_card && (
                          <InputTypeText
                            autosaveFeedBack={
                              <AutosaveFeedback
                                status={get(fields, 'electoral_card')}
                              />
                            }
                            field="electoral_card"
                            label="Titulo de Eleitor"
                            col="3"
                            required
                            onValueChange={(value) =>
                              this.debouncedPartialSave('electoral_card', value)
                            }
                          />
                        )}
                        {this.displayMilitaryCertificate(formState) &&
                          dynamicFields.military_certificate && (
                            <InputTypeText
                              autosaveFeedBack={
                                <AutosaveFeedback
                                  status={get(fields, 'military_certificate')}
                                />
                              }
                              field="military_certificate"
                              label="Certificado Militar"
                              col="3"
                              required
                              onValueChange={(value) =>
                                this.debouncedPartialSave(
                                  'military_certificate',
                                  value
                                )
                              }
                            />
                          )}
                      </>
                    )}
                  </FieldSet>
                  <FieldSet>
                    {dynamicFields.fathers_name && (
                      <InputTypeText
                        field="fathers_name"
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'fathers_name')}
                          />
                        }
                        label="Nome do Pai"
                        helper="Nome completo do seu pai"
                        col="6"
                        onValueChange={(value) =>
                          this.debouncedPartialSave('fathers_name', value)
                        }
                      />
                    )}
                    {dynamicFields.mothers_name && (
                      <InputTypeText
                        field="mothers_name"
                        autosaveFeedBack={
                          <AutosaveFeedback
                            status={get(fields, 'mothers_name')}
                          />
                        }
                        label="Nome da Mãe"
                        helper="Nome completo da sua mãe"
                        col="6"
                        required
                        onValueChange={(value) =>
                          this.debouncedPartialSave('mothers_name', value)
                        }
                      />
                    )}
                  </FieldSet>
                  {(dynamicFields.instagram_url ||
                    dynamicFields.twitter_url ||
                    dynamicFields.tiktok_url) && (
                    <FieldSet title="Redes Sociais">
                      {dynamicFields.instagram_url && (
                        <InputSocialMedia
                          field="instagram_url"
                          autosaveFeedBack={
                            <AutosaveFeedback
                              status={get(fields, 'instagram_url')}
                            />
                          }
                          label="Perfil do Instagram"
                          helper="Link do seu Instagram"
                          col="6"
                          onValueChange={(value) =>
                            this.debouncedPartialSave('instagram_url', value)
                          }
                        />
                      )}

                      {dynamicFields.twitter_url && (
                        <InputSocialMedia
                          field="twitter_url"
                          autosaveFeedBack={
                            <AutosaveFeedback
                              status={get(fields, 'twitter_url')}
                            />
                          }
                          label="Perfil do X (Twitter)"
                          helper="Link do seu X (Twitter)"
                          col="6"
                          onValueChange={(value) =>
                            this.debouncedPartialSave('twitter_url', value)
                          }
                        />
                      )}

                      {dynamicFields.tiktok_url && (
                        <InputSocialMedia
                          field="tiktok_url"
                          autosaveFeedBack={
                            <AutosaveFeedback
                              status={get(fields, 'tiktok_url')}
                            />
                          }
                          label="Perfil do TikTok"
                          helper="Link do seu TikTok"
                          col="6"
                          onValueChange={(value) =>
                            this.debouncedPartialSave('tiktok_url', value)
                          }
                        />
                      )}
                    </FieldSet>
                  )}
                  {dynamicFields.contact && (
                    <Contato
                      fields={fields}
                      onValueChange={this.debouncedPartialSave}
                      email={dynamicFields.email}
                      phoneNumber={dynamicFields.phone_number}
                      landline={dynamicFields.landline}
                      extraPhoneNumber={dynamicFields.extra_phone_number}
                    />
                  )}
                  {dynamicFields.address && (
                    <Endereco
                      fields={fields}
                      onValueChange={this.debouncedPartialSave}
                      formApi={formApi}
                      dbCep={formState.zip_code}
                      zipCode={dynamicFields.zip_code}
                      streetAddress={dynamicFields.street_address}
                      addressNumber={dynamicFields.address_number}
                      complementAddress={dynamicFields.complement_address}
                      neighborhood={dynamicFields.neighborhood}
                      state={dynamicFields.state}
                      city={dynamicFields.city}
                    />
                  )}
                </>
              )}
              {dynamicFields.handicap && (
                <>
                  <FieldSet title="Outras Informações" />
                  <HandicapForm
                    autosaveFeedBack={
                      <AutosaveFeedback status={get(fields, 'handicap')} />
                    }
                    options={handicapOptions}
                    error={get(formState, 'errors.handicap[0]')}
                    onValueChange={this.debouncedPartialSave}
                  />
                  {this.displayDisabilities(formState) && (
                    <>
                      <DisabilitiesForm
                        options={disabilities}
                        selectedDisabilities={selectedDisabilities}
                        error={get(formState, 'errors.disabilities[0]')}
                        handleChange={this.handleDisabilityChange}
                      />
                      <SpecialNeedsForm
                        options={specialNeeds}
                        selectedDisabilities={selectedDisabilities}
                        selectedSpecialNeeds={selectedSpecialNeeds}
                        error={get(formState, 'errors.special_needs[0]')}
                        handleChange={this.handleSpecialNeedChange}
                      />
                    </>
                  )}
                </>
              )}
              <hr />
              <div className="text-right">
                <div className="col-md-4 p-0 offset-md-8 col-sm-12">
                  {!isAcademic && (
                    <div className="btn-actions">
                      <button
                        className="btn btn-black mr-2"
                        type="submit"
                        onClick={() => this.props.backClick()}
                      >
                        Voltar
                      </button>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={
                          nomeSocial
                            ? () =>
                                this.setState({
                                  showConfirmationModalNomeSocial: true,
                                })
                            : () => this.validatePersonalData(formApi)
                        }
                      >
                        {loading ? 'Carregando...' : 'Próximo'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <Modal
                visible={showConfirmationModalNomeSocial}
                title="Atenção!"
                onCancel={() =>
                  this.setState({ showConfirmationModalNomeSocial: false })
                }
                onConfirm={() =>
                  this.validatePersonalData(formApi) +
                  this.setState({ showConfirmationModalNomeSocial: false })
                }
              >
                <text style={{ fontSize: '20px' }}>
                  Você tem certeza que deseja trocar seu <b>nome civil</b>{' '}
                  <b style={{ color: 'red' }}>
                    "{this.formApi.getState().values.real_name}"
                  </b>{' '}
                  para o <b>nome social</b>{' '}
                  <b style={{ color: 'red' }}>
                    "{this.formApi.getState().values.assumed_name}"
                  </b>
                  ?<br />
                  Essa ação vai alterar todos os processos administrativos e
                  relatorios que referenciam o seu nome.
                </text>
              </Modal>
            </Spinner>
            {isAcademic && (
              <div className="btn-actions">
                <button
                  type="button"
                  className="float-button mr-6"
                  disabled={loading}
                  onClick={() => onEdit()}
                >
                  <FontAwesomeIcon icon="times" />
                </button>
                <button
                  type="button"
                  className="float-button"
                  disabled={loading}
                  onClick={() => this.validatePersonalData(formApi)}
                >
                  <FontAwesomeIcon icon="check" />
                </button>
              </div>
            )}
          </>
        )}
      </Form>
    );
  }
}

PersonalDataStep.propTypes = {
  onClick: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
};

PersonalDataStep.defaultProps = {
  onEdit: () => {},
};

export default withRouter(PersonalDataStep);
